import styled from 'styled-components';
import { border } from 'styled-system';
import { Box } from '../Box/Box';
import { applyVariations, getPaletteColor } from '../utils/utils';
const styleAsButton = ({
  as,
  ...props
}) => as === 'button' ? `
      font-family : inherit;
      &:hover {
        cursor: pointer;
        box-shadow: ${props.theme.shadows.xl};
      }` : '';
/**
 * @public
 */
export const Card = /*#__PURE__*/styled(Box).withConfig({
  displayName: "Card",
  componentId: "sc-1iw8zza-0"
})(["", " ", " border-color:", ";", ";"], applyVariations('Card'), styleAsButton, props => props.borderWidth === 0 ? '0' : getPaletteColor(props.borderColor, 'base')(props), border);
Card.defaultProps = {
  borderColor: 'border',
  borderRadius: 'xsm',
  borderStyle: 'solid',
  borderWidth: 1
};
Card.displayName = 'Card';